import { gql } from '@apollo/client/core'

export const keywordAutoSuggestionQuery = gql`
  query keywordAutoSuggestion(
    $keyword: String!
  ) {
  keywordAutoSuggestion(
    keyword: $keyword
  ) {
    items
    }
  }
`
